class ScrollTop {
  constructor(el, opt) {
    this.el = el;
    this.event();
  }
  event() {
    $(function () {
      const pageTop = $('#js-pageTop');
      
      pageTop.click( () => {
        $('body, html').animate({
            scrollTop: 0
        }, 600);
        return false;
      });
    });
  }
}
